import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useFundnowApi } from '../api';
import { LoadingButton } from '@mui/lab';

export interface ArchiveDialogProps {
    open: boolean;
    invoiceId: string;
    onClose: (archived: boolean) => void;
}

export default function ArchiveDialog({ open, invoiceId, onClose }: ArchiveDialogProps) {
    const [loading, setLoading] = useState(false);
    const api = useFundnowApi();

    const handleClose = () => {
        onClose(false);
    };

    const handleAgree = async () => {
        setLoading(true);
        await api.archiveInvoice(invoiceId);
        onClose(true);
        setTimeout(() => {
            setLoading(false);
        }, 3000);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                sx: {
                    paddingY: 1,
                    paddingX: 1,
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to delete this invoice?
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    You will have to re-upload the invoice if you want to fund this invoice again.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Cancel
                </Button>
                <LoadingButton
                    loading={loading}
                    onClick={handleAgree}
                    autoFocus
                    variant="contained"
                    color="error"
                    sx={{
                        'backgroundColor': 'error.dark',
                        'color': 'white',
                        '&:hover': {
                            backgroundColor: 'error.main',
                        },
                    }}
                >
                    Delete invoice
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
